module.exports = __webpack_public_path__ + "img/yilianGl10.5afd212e.png";